import Raven from "raven-js";

import db from "./db.js";
import eventHub from "./eventHub.js";

let provider = new firebase.auth.GoogleAuthProvider();
let initialized = false;

firebase.auth().onAuthStateChanged(function(user) {
  initialized = true;

  if (user) {
    eventHub.$emit("user-logged-in");
    Raven.setUserContext({
      email: user.email,
      id: user.uid,
    });
  } else {
    eventHub.$emit("user-logged-out");
    Raven.setUserContext();
  }
});

export default {
  isInitialized() {
    return initialized;
  },
  getUser() {
    return firebase.auth().currentUser;
  },
  isBetaUser() {
    return db.isBetaUser();
  },
  loggedIn() {
    return this.getUser() !== null;
  },
  signIn() {
    //FIXME - Change to redirect for mobile
    //firebase.auth().signInWithRedirect(provider);
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function(result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
        // The signed-in user info.
        var user = result.user;

        // console.log(token, user);
        // ...
      })
      .catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...

        //FIXME - DO SOMETHING HERE
      });
  },
  signOut() {
    firebase
      .auth()
      .signOut()
      .then(
        function() {
          // TODO - Determine if we need to do anything here
        },
        function(error) {
          // FIXME - Do something here
          console.error("Sign Out Error", error);
        }
      );
  },
};



// WEBPACK FOOTER //
// ./dev/src/auth.js